import React from 'react';
type Status = 'pending' | 'approved' | 'rejected' | 'active' | 'expired' | 'blacklisted' | 'open' | 'resolved' | 'escalated' | 'suspended' | 'lost' | 'replaced';
interface StatusBadgeProps {
  status: Status;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const styles: Record<Status, string> = {
    pending: 'bg-yellow-100 text-yellow-800',
    approved: 'bg-green-100 text-green-800',
    rejected: 'bg-red-100 text-red-800',
    active: 'bg-blue-100 text-blue-800',
    expired: 'bg-gray-100 text-gray-800',
    blacklisted: 'bg-red-900 text-white',
    open: 'bg-orange-100 text-orange-800',
    resolved: 'bg-green-100 text-green-800',
    escalated: 'bg-red-100 text-red-800',
    suspended: 'bg-gray-100 text-gray-800',
    lost: 'bg-gray-100 text-gray-800',
    replaced: 'bg-blue-100 text-blue-800'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styles[status]}`} data-id="element-139">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>;
}